import { Box, FormControlLabel, Switch, Typography } from '@mui/material'
import MailOutlineIcon from '@mui/icons-material/MailOutline'
import { Secao } from '.'

interface SecaoAvisosClienteProps {
  valor: boolean | undefined
  onChange: (ligado: boolean) => void
}

export function SecaoAvisosCliente({ valor, onChange }: SecaoAvisosClienteProps): JSX.Element {
  return (
    <Secao icone={<MailOutlineIcon />} titulo="Avisos ao cliente" descricao="Como o cliente acompanha o pedido.">
      <FormControlLabel
        control={<Switch checked={valor ?? true} onChange={(_e, ligado) => onChange(ligado)} />}
        label={
          <Box sx={{ ml: 1.5 }}>
            <Typography>Enviar e-mail de acompanhamento</Typography>
            <Typography variant="caption" color="text.secondary">
              Avisa o cliente por e-mail quando o pedido é confirmado, fica pronto, sai para entrega, é entregue ou
              cancelado. Desligado, ele acompanha e avalia só pela tela do pedido. O código para entrar na conta
              continua indo por e-mail.
            </Typography>
          </Box>
        }
        sx={{ alignItems: 'flex-start', m: 0 }}
      />
    </Secao>
  )
}
